import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  TextField,
} from '@mui/material';
import PopupTitle from '../common/popup_title';

const LogFoodItemPromptPage = ({
  prompt,
  setPrompt,
  isLoading,
  recentlyLoggedDistilledMeals,
  onChooseRecentlyLoggedDistilledMeal,
  onClickLog,
  onDismiss,
}) => {
  const isValid = prompt.length > 0;

  return (
    <Dialog open maxWidth="sm" fullWidth>
      <Grid container>
        <Grid item xs={12}>
          <PopupTitle
            closeButtonEnabled
            onClickClose={onDismiss}
            titleText="Log a food item"
          />
        </Grid>
        <Grid item xs={12}>
          <DialogContent>
            <div style={{ marginTop: '16px' }}>
              Describe your food item, and we&apos;ll calculate the nutrition
            </div>
            <div style={{ display: 'flex', marginTop: '16px' }}>
              <TextField
                variant="filled"
                size="small"
                fullWidth
                autoFocus
                multiline
                rows={4}
                value={prompt}
                onChange={(event) => setPrompt(event.target.value)}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Grid container>
              <Grid
                item
                xs={12}
                style={{ margin: 'auto 10px', padding: '6px' }}>
                <Button
                  variant="contained"
                  onClick={onClickLog}
                  disabled={isLoading || !isValid}>
                  Log
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
          <DialogContent>
            <div>or select from recently added items</div>
            <div className="logFoodItemRecentlyAddedItems">
              <ul>
                {recentlyLoggedDistilledMeals.map((meal) => (
                  <li key={meal.id}>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      href="#"
                      onClick={() => onChooseRecentlyLoggedDistilledMeal(meal)}
                      style={{ margin: '0 10px' }}>
                      {meal.recipes[0].title}
                    </a>
                  </li>
                ))}
              </ul>
              {recentlyLoggedDistilledMeals.length === 0 && (
                <div style={{ margin: '0 10px' }}>No recently added items</div>
              )}
            </div>
          </DialogContent>
        </Grid>
      </Grid>
    </Dialog>
  );
};

LogFoodItemPromptPage.propTypes = {
  prompt: PropTypes.string.isRequired,
  setPrompt: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  recentlyLoggedDistilledMeals: PropTypes.array.isRequired,
  onChooseRecentlyLoggedDistilledMeal: PropTypes.func.isRequired,
  onClickLog: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default LogFoodItemPromptPage;
